module.exports = __webpack_public_path__ + "assets/img/login_main.02759a02.png";